import { Column } from './types'


export function useColumnsArranged() {
  return Object.values(Column)
}
